import React from "react";
import MainLayout from "../../../hoc/main";
import {FormContainer, Grid, Input} from "../../../components";
import {connect} from "react-redux";
import {addVideoData} from "../../../redux/modules/Video/action";
import {Button} from "../../../components/Button";
import {Redirect} from "react-router-dom";

class VideoAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            video: "",
            filename: "",
        };
    }

    onChangeValue = (e) => {
        const {value, name} = e.target;

        this.setState({
            [name]: value,
        });
    };

    finishForm(e) {
        e.preventDefault();
        this.props.addVideoData(this.state);
    }

    render() {
        if (this.props.video?.success) return <Redirect to="/video"/>;
        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <FormContainer className={`pt-0`}>
                        <Input
                            name={"name"}
                            label={"name"}
                            value={this.state.name}
                            placeholder={"Lorem"}
                            className={"w-full md:w-1/2 xl:w-1/3"}
                            onChange={this.onChangeValue}
                        />
                        <Input
                            name={"video"}
                            label={"Video Link"}
                            value={this.state.video}
                            placeholder={"Loremmp.4"}
                            className={"w-full md:w-1/2 xl:w-1/3"}
                            onChange={this.onChangeValue}
                        />
                        <Input
                            name={"filename"}
                            label={"Filename"}
                            value={this.state.filename}
                            placeholder={"Lorem.mp4"}
                            className={"w-full md:w-1/2 xl:w-1/3"}
                            onChange={this.onChangeValue}
                        />
                        <hr className={`my-5`}/>
                        <Button
                            className={`bg-green-200 text-green-700`}
                            onClick={this.finishForm.bind(this)}
                        >
                            Submit
                        </Button>
                    </FormContainer>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    video: state.video,
});

const mapDispatchToProps = {
    addVideoData,
};

export default MainLayout(
    connect(mapStateToProps, mapDispatchToProps)(VideoAdd)
);
